import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-user',
  templateUrl: './home.component.html',
  styles: [],
  standalone: false,
})
export class HomeComponent implements OnInit {
  // constructor(private translocoService: thanosSnap) {}

  logos :string[] = ['./assets/partners/logo1.png','./assets/partners/logo2.png','./assets/partners/logo3.svg','./assets/partners/logo4.png','./assets/partners/logo5.png','./assets/partners/logo6.png']

  ngOnInit(): void {}

  snap(elementId: string) {
  }
}
